import request from '../request'
// params为query data为body
export function mockPageList(data) {
  return request({
    url: '/mockPageList',
    method: 'post',
    data
  })
}
export function mockAllList(params) {
  return request({
    url: '/mockAllList',
    method: 'post',
    params
  })
}

export function mockLogin(params) {
  return request({
    url: '/mockReturn',
    method: 'post',
    params
  })
}